import { PageHeader } from "@/components/shared/PageHeader";
import { DocumentsSection } from "@/components/home/DocumentsSection";
import { TimeTable2026 } from "@/components/shared/TimeTable2026";

const IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts/pwf4y2x8_DSC07033.webp";

export default function Tavlingsinformation() {
  return (
    <>
      <PageHeader kicker="För förare & team" title="Tävlingsinformation" subtitle="Datum, område, anmälan, klasser och regler. Uppdateras löpande fram till tävlingshelgen." image={IMG} />
      <DocumentsSection limit={6} />
      <TimeTable2026 />
    </>
  );
}
